// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wjms","inner":"Footer_inner__1pbUY"};